import type { PackageResourceResponse } from "@southfields-digital/mxmz-resource-model";
import { useEffect, useState } from "react";

import { getPackageResources } from "./api";

/** `failed` is the request itself failing; an unreadable resource is an entry. */
export type PackageResources = {
	resources: PackageResourceResponse[];
	loading: boolean;
	failed: boolean;
};

export const usePackageResources = (packageId: string | undefined): PackageResources => {
	const [state, setState] = useState<PackageResources>({
		resources: [],
		loading: false,
		failed: false,
	});

	useEffect(() => {
		if (!packageId) {
			setState({ resources: [], loading: false, failed: false });
			return;
		}

		let cancelled = false;
		setState({ resources: [], loading: true, failed: false });

		getPackageResources(packageId)
			.then((resources) => {
				if (!cancelled) setState({ resources, loading: false, failed: false });
			})
			.catch(() => {
				if (!cancelled) setState({ resources: [], loading: false, failed: true });
			});

		return () => {
			cancelled = true;
		};
	}, [packageId]);

	return state;
};
